import { inject, observer } from "mobx-react";
import { useState, useEffect } from "react";
import Tooltip from "sharedComponents/Tooltip";
import { baseUrl, contract_types } from "stores/main";
import ShowDocument from "../../Modals/ShowDocument/index";

import { Form } from "react-bootstrap";
import "./information.scss";

import MaskedInput from "@biproxi/react-text-mask";
import { Field, Formik } from "formik";

import {
  codeNumberMask,
  refreshUserDataFiles,
  snilsNumberMask
} from "../../Validation/index";

import iconCheck from "images/iconCheck.svg";
import plus from "images/plus.svg";
import FilesInfo from "sharedComponents/FilesInfo";
import Select from "sharedComponents/Select";
import { fileAccept, isFileAllowed } from "utils/consts";
import FileUploadErrorModal from "../../Modals/FileUploadErrorModal/index";

const DocumentsTooltipSync = ({
  hasChecked,
  hasRequiredFields,
  hasRequiredFiles,
  isProfileChecking,
  setTooltipMessage
}) => {
  useEffect(() => {
    const id = setTimeout(() => {
      if (!hasChecked && (!hasRequiredFields || !hasRequiredFiles)) {
        setTooltipMessage(
          "Для отправки на проверку нужно заполнить обязательные поля и прикрепить обязательные документы"
        );
      } else if (isProfileChecking) {
        setTooltipMessage("Документы на проверке");
      } else if (hasChecked) {
        setTooltipMessage("Ваши документы уже подтверждены");
      }
    }, 100);
    return () => clearTimeout(id);
  }, [
    hasChecked,
    hasRequiredFields,
    hasRequiredFiles,
    isProfileChecking,
    setTooltipMessage
  ]);
  return null;
};

const Documents = ({
  sendAgentFile,
  userData,
  userFiles,
  userRequired,
  refreshUserData,
  newData,
  documentUrl,
  setOpenModalDocument,
  setDocumentUrl,
  openModalDocument,
  setFileUploadErrorModal,
  fileUploadErrorModal,
  setApproved
}) => {
  const [passportFileBlocked, setPassportFileBlocked] = useState(false);
  const [passportFile1Blocked, setPassportFile1Blocked] = useState(false);
  const [innFileBlocked, setInnFileBlocked] = useState(false);
  const [snilsFileBlocked, setSnilsFileBlocked] = useState(false);
  const [contractBlocked, setContractBlocked] = useState(false);
  const [registerSelfBlocked, setRegisterSelfBlocked] = useState(false);
  const [registerIPBlocked, setRegisterIPBlocked] = useState(false);

  const [addDocsBlocked, setAddDocsBlocked] = useState(false);
  const [addDocsError, setAddDocsError] = useState(null);

  const [isFileBtnTouched, setIsFileBtnTouched] = useState(false);

  const showModalErrorType = async (id, file_name, file) => {
    if (!isFileAllowed(file)) {
      setFileUploadErrorModal(true);
    } else {
      setFileUploadErrorModal(false);
      await sendAgentFile({
        id: id,
        file_name: file_name,
        file: file
      });
    }
  };

  const showModalErrorTypeSeveral = async (id, files) => {
    const currentFilesLength = [2, 3, 4, 5, 6]
      .map((num) => `passport${num}`)
      .map((val) => {
        return userFiles[val] && userFiles[val] !== -1 && val;
      })
      .filter(Boolean).length;

    if (currentFilesLength + files.length > 5) {
      setAddDocsError("Не более 5 файлов");
    } else {
      let idx = currentFilesLength + 2;

      let reqs = [];
      let hasRejected = false;

      for (const file of files) {
        if (!isFileAllowed(file)) {
          hasRejected = true;
        } else {
          reqs.push(
            sendAgentFile({
              id: id,
              file_name: `passport${idx}`,
              file: file
            })
          );
          idx++;
        }
      }

      setFileUploadErrorModal(hasRejected);

      await Promise.all(reqs);
    }
  };

  const passportFields = [
    "passport_number",
    "passport_series",
    "passport_code",
    "passport_date",
    "passport_propiska",
    "passport_place"
  ];

  const [tooltipMessage, setTooltipMessage] = useState("");

  const filesForApproval = [
    "passport_number",
    "passport_propiska",
    "contract_type",
    "inn",
    "snils"
  ].map((file) => `${file}_approved`);

  return (
    <>
      <Formik
        initialValues={{
          contract_type: userData["contract_type"]
            ? userData["contract_type"]
            : "",
          contract_number: userData["contract_number"]
            ? userData["contract_number"]
            : "",
          surname: userData["surname"] ? userData["surname"] : "",
          name: userData["name"] ? userData["name"] : "",
          patronymic: userData["patronymic"] ? userData["patronymic"] : "",
          birth_place: userData["birth_place"] ? userData["birth_place"] : "",
          birthday: userData["birthday"] ? userData["birthday"] : "",
          phone: userData["phone"] ?? "",
          email: userData["email"] ? userData["email"] : "",
          password: "",
          confirmPassword: "",
          pasp_files: "",
          passport_number: userData["passport_number"]
            ? userData["passport_number"]
            : "",
          passport_series: userData["passport_series"]
            ? userData["passport_series"]
            : "",
          passport_code: userData["passport_code"]
            ? userData["passport_code"]
            : "",
          passport_date: userData["passport_date"]
            ? userData["passport_date"]
            : "",
          passport_place: userData["passport_place"]
            ? userData["passport_place"]
            : "",
          passport_propiska: userData["passport_propiska"]
            ? userData["passport_propiska"]
            : "",
          snils: userData["snils"] ? userData["snils"] : "",
          inn: userData["inn"] ? userData["inn"] : "",
          bankaccount: userData["bank_payment_account"]
            ? userData["bank_payment_account"]
            : "",
          bankname: userData["bank_name"] ? userData["bank_name"] : "",
          bank_recipient: userData["bank_recipient"]
            ? userData["bank_recipient"]
            : "",
          banknumber: userData["bank_inn"] ? userData["bank_inn"] : "",
          bankbik: userData["bank_bik"] ? userData["bank_bik"] : "",
          bankkpp: userData["bank_kpp"] ? userData["bank_kpp"] : "",
          bankkor: userData["bank_correspondent_account"]
            ? userData["bank_correspondent_account"]
            : ""
        }}
        validateOnBlur
        onSubmit={async (values) => {
          await refreshUserData(values);
          newData();
        }}
        validationSchema={refreshUserDataFiles}
        enableReinitialize
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          isValid,
          handleSubmit,
          dirty,
          setFieldTouched
        }) => {
          const hasRequiredFields =
            userRequired &&
            userRequired.fields.update.every((field) => values[field]) &&
            !userRequired.fields.update.every((field) => errors[field]);

          const hasRequiredFiles =
            userRequired &&
            values.contract_type &&
            userFiles &&
            userRequired.files[values.contract_type].every(
              (field) => userFiles[field] !== -1
            );

          const hasMain = userData && hasRequiredFields && hasRequiredFiles;

          const isProfileChecking =
            hasMain &&
            (filesForApproval.some((file) => userData[file] == "0") ||
              (values.contract_type === "ip"
                ? userData["nalog_register_ip_approved"] == "0"
                : values.contract_type === "self"
                ? userData["nalog_register_self_approved"] == "0"
                : false));

          const hasChecked =
            userData &&
            filesForApproval.every((file) => userData[file] == "1") &&
            (values.contract_type === "ip"
              ? userData["nalog_register_ip_approved"] == "1"
              : values.contract_type === "self"
              ? userData["nalog_register_self_approved"] == "1"
              : true);

          return (
            <>
              <DocumentsTooltipSync
                hasChecked={hasChecked}
                hasRequiredFields={hasRequiredFields}
                hasRequiredFiles={hasRequiredFiles}
                isProfileChecking={isProfileChecking}
                setTooltipMessage={setTooltipMessage}
              />
              <Form className="information-form">
              {(!hasRequiredFields || !hasRequiredFiles) && !hasChecked ? (
                <p className="information-error pt-2 pb-2 mb-3">
                  Для подтверждения аккаунта нужно заполнить обязательные поля и
                  прикрепить обязательные документы
                </p>
              ) : null}

              <Form.Group className="mb-3">
                <Form.Label className="d-flex justify-content-between align-items-center m-0 mb-1">
                  <div className="d-flex gap-2">
                    <p className="m-0">Тип сотрудничества*</p>
                    {userFiles["contract"] && userFiles["contract"] !== -1 ? (
                      <img
                        alt=""
                        src={iconCheck}
                        className={
                          userData["contract_type_approved"] == "1"
                            ? "iconCheck_approved"
                            : ""
                        }
                      />
                    ) : null}
                    <div className="files-info-container files-info-container_small">
                      <FilesInfo
                        hasFiles={
                          userFiles["contract"] && userFiles["contract"] !== -1
                        }
                      >
                        {[
                          {
                            file: userFiles["contract"],
                            handleClick: () => {
                              setOpenModalDocument(true);
                              setDocumentUrl(
                                `${baseUrl}${
                                  userFiles["contract"]
                                }?${Date.now()}`
                              );
                            }
                          }
                        ]}
                      </FilesInfo>
                    </div>
                  </div>
                  {userFiles["contract"] &&
                  userFiles["contract"] !== -1 ? null : (
                    <div className="information-form__label text-end">
                      Прикрепите файл
                    </div>
                  )}
                </Form.Label>
                <div className="d-flex gap-2 flex-wrap">
                  <Form.Group className="flex-grow-1 info-row">
                    <Field
                      as={Select}
                      name="contract_type"
                      options={contract_types}
                      selected={
                        values.contract_type
                          ? contract_types[values.contract_type]
                          : ""
                      }
                    />
                  </Form.Group>
                  <div className="d-flex align-items-center gap-3 align-self-start">
                    <label className="btn-files w-auto">
                      <input
                        type="file"
                        accept={fileAccept}
                        hidden
                        disabled={contractBlocked}
                        onChange={async (e) => {
                          setContractBlocked(true);
                          await showModalErrorType(
                            userData["id"],
                            "contract",
                            e.target.files[0]
                          );
                          setApproved("contract_type_approved");
                          setContractBlocked(false);
                          setIsFileBtnTouched(true);
                        }}
                      />
                      <img src={plus} alt="" />
                    </label>
                    {userFiles["contract"] && userFiles["contract"] !== -1 ? (
                      <div className="files-container">
                        <FilesInfo
                          hasFiles={
                            userFiles["contract"] &&
                            userFiles["contract"] !== -1
                          }
                        >
                          {[
                            {
                              file: userFiles["contract"],
                              handleClick: () => {
                                setOpenModalDocument(true);
                                setDocumentUrl(
                                  `${baseUrl}${
                                    userFiles["contract"]
                                  }${Date.now()}`
                                );
                              }
                            }
                          ]}
                        </FilesInfo>
                      </div>
                    ) : (
                      <div className="information-form__label information-form__label_small text-end">
                        Прикрепите файл
                      </div>
                    )}
                  </div>
                </div>
              </Form.Group>
              <Form.Label className="d-flex justify-content-between align-items-center m-0 mb-1">
                <div className="d-flex gap-2">
                  <div className="d-flex gap-2">
                    <p className="m-0">Паспорт*</p>
                    {userFiles["passport"] !== -1 ||
                    userFiles["passport1"] !== -1 ? (
                      <img
                        alt=""
                        src={iconCheck}
                        className={
                          userData["passport_number_approved"] == "1" &&
                          userData["passport_propiska_approved"] == "1"
                            ? "iconCheck_approved"
                            : ""
                        }
                      />
                    ) : null}
                  </div>
                  <div className="files-info-container files-info-container_small">
                    <FilesInfo
                      hasFiles={
                        userFiles["passport"] !== -1 ||
                        userFiles["passport1"] !== -1
                      }
                    >
                      {[
                        {
                          file: userFiles["passport"],
                          handleClick: () => {
                            setOpenModalDocument(true);
                            setDocumentUrl(
                              `${baseUrl}${userFiles["passport"]}?${Date.now()}`
                            );
                          }
                        },
                        {
                          file: userFiles["passport1"],
                          handleClick: () => {
                            setOpenModalDocument(true);
                            setDocumentUrl(
                              `${baseUrl}${
                                userFiles["passport1"]
                              }?${Date.now()}`
                            );
                          }
                        }
                      ]}
                    </FilesInfo>
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  {userFiles["passport"] !== -1 ||
                  userFiles["passport1"] !== -1 ? null : (
                    <div className="information-form__label text-end">
                      Прикрепите файлы
                    </div>
                  )}
                  <Tooltip
                    position="bottom"
                    text="Прикрепите главную страницу паспорта, и страницу с пропиской"
                  />
                </div>
              </Form.Label>

              <div className="d-flex flex-wrap justify-content-between mb-3 information-row">
                <div className="d-flex flex-wrap w-100 gap-2 mb-2">
                  <Form.Group className="flex-grow-1">
                    <Form.Control
                      className="information-placeholder"
                      type="tel"
                      name="passport_series"
                      placeholder="Серия"
                      value={values.passport_series}
                      onChange={handleChange}
                      onFocus={() => {
                        for (const field of passportFields) {
                          setFieldTouched(field, true);
                        }
                      }}
                      onBlur={handleBlur}
                      isInvalid={
                        touched.passport_series && errors.passport_series
                      }
                    />
                    {errors.passport_series &&
                      !errors.passport_series.charAt(0).match(/з/gi) && (
                        <Form.Control.Feedback type="invalid">
                          {errors.passport_series}
                        </Form.Control.Feedback>
                      )}
                  </Form.Group>
                  <div className="flex-grow-1 d-flex gap-2">
                    <Form.Group className="flex-grow-1">
                      <Form.Control
                        className="information-placeholder"
                        type="tel"
                        name="passport_number"
                        placeholder="Номер"
                        value={values.passport_number}
                        onChange={handleChange}
                        onFocus={() => {
                          for (const field of passportFields) {
                            setFieldTouched(field, true);
                          }
                        }}
                        onBlur={handleBlur}
                        isInvalid={
                          touched.passport_number && errors.passport_number
                        }
                      />
                      {errors.passport_number &&
                        !errors.passport_number.charAt(0).match(/з/gi) && (
                          <Form.Control.Feedback type="invalid">
                            {errors.passport_number}
                          </Form.Control.Feedback>
                        )}
                    </Form.Group>
                    <label className="btn-files w-auto">
                      <input
                        type="file"
                        accept={fileAccept}
                        hidden
                        disabled={passportFileBlocked}
                        onChange={async (e) => {
                          setPassportFileBlocked(true);
                          await showModalErrorType(
                            userData["id"],
                            "passport",
                            e.target.files[0]
                          );
                          setApproved("passport_number_approved");
                          setApproved("passport_propiska_approved");
                          setPassportFileBlocked(false);
                          setIsFileBtnTouched(true);
                        }}
                      />
                      <img src={plus} alt="" />
                    </label>
                  </div>
                </div>
                <div className="d-flex w-100 mb-2">
                  <Form.Group className="flex-grow-1">
                    <Form.Control
                      className="information-placeholder"
                      name="passport_propiska"
                      placeholder="Адрес прописки"
                      value={values.passport_propiska}
                      onChange={handleChange}
                      onFocus={() => {
                        for (const field of passportFields) {
                          setFieldTouched(field, true);
                        }
                      }}
                      onBlur={handleBlur}
                      isInvalid={
                        touched.passport_propiska && errors.passport_propiska
                      }
                    />
                    {errors.passport_propiska &&
                      !errors.passport_propiska.charAt(0).match(/з/gi) && (
                        <Form.Control.Feedback type="invalid">
                          {errors.passport_propiska}
                        </Form.Control.Feedback>
                      )}
                  </Form.Group>
                  <Form.Group>
                    <label className="btn-files ms-2">
                      <input
                        type="file"
                        accept={fileAccept}
                        hidden
                        disabled={passportFile1Blocked}
                        onChange={async (e) => {
                          setPassportFile1Blocked(true);
                          await showModalErrorType(
                            userData["id"],
                            "passport1",
                            e.target.files[0]
                          );
                          setApproved("passport_number_approved");
                          setApproved("passport_propiska_approved");
                          setPassportFile1Blocked(false);
                          setIsFileBtnTouched(true);
                        }}
                      />
                      <img src={plus} alt="" />
                    </label>
                  </Form.Group>
                </div>

                <Form.Group className="flex-grow-1 mb-2 me-lg-2 me-md-2 me-sm-2 passport_date-group">
                  <Form.Control
                    className="information-placeholder passport_date w-100"
                    type="date"
                    max="2999-12-31"
                    name="passport_date"
                    onChange={handleChange}
                    onFocus={() => {
                      for (const field of passportFields) {
                        setFieldTouched(field, true);
                      }
                    }}
                    onBlur={handleBlur}
                    value={values.passport_date}
                    isInvalid={touched.passport_date && errors.passport_date}
                  />
                  {errors.passport_date &&
                    !errors.passport_date.charAt(0).match(/з/gi) && (
                      <Form.Control.Feedback type="invalid">
                        {errors.passport_date}
                      </Form.Control.Feedback>
                    )}
                </Form.Group>
                <Form.Group className="flex-grow-1 mb-2">
                  <Field name="passport_code">
                    {({ field }) => (
                      <MaskedInput
                        {...field}
                        mask={codeNumberMask}
                        placeholder="Код подразделения"
                        type="text"
                        onChange={handleChange}
                        onFocus={() => {
                          for (const field of passportFields) {
                            setFieldTouched(field, true);
                          }
                        }}
                        onBlur={handleBlur}
                        className={`information-placeholder ${
                          touched.passport_code && errors.passport_code
                            ? "form-control is-invalid"
                            : "form-control"
                        }`}
                      />
                    )}
                  </Field>
                  {errors.passport_code &&
                    !errors.passport_code.charAt(0).match(/з/gi) && (
                      <Form.Control.Feedback type="invalid">
                        {errors.passport_code}
                      </Form.Control.Feedback>
                    )}
                </Form.Group>

                <Form.Group className="flex-grow-1 w-100">
                  <Form.Control
                    className="information-placeholder"
                    name="passport_place"
                    placeholder="Кем выдан"
                    value={values.passport_place}
                    onChange={handleChange}
                    onFocus={() => {
                      for (const field of passportFields) {
                        setFieldTouched(field, true);
                      }
                    }}
                    onBlur={handleBlur}
                    isInvalid={touched.passport_place && errors.pasport_place}
                  />
                  {passportFields.some((val) => !!errors[val]) ? (
                    <div className="form-error mt-1">
                      Заполните все данные паспорта
                    </div>
                  ) : null}
                </Form.Group>
                <div className="files-container mt-2">
                  <FilesInfo
                    hasFiles={
                      userFiles["passport"] !== -1 ||
                      userFiles["passport1"] !== -1
                    }
                  >
                    {[
                      {
                        file: userFiles["passport"],
                        handleClick: () => {
                          setOpenModalDocument(true);
                          setDocumentUrl(
                            `${baseUrl}${userFiles["passport"]}?${Date.now()}`
                          );
                        }
                      },
                      {
                        file: userFiles["passport1"],
                        handleClick: () => {
                          setOpenModalDocument(true);
                          setDocumentUrl(
                            `${baseUrl}${userFiles["passport1"]}?${Date.now()}`
                          );
                        }
                      }
                    ]}
                  </FilesInfo>
                </div>
              </div>
              {values["contract_type"] === "self" ? (
                <Form.Group className="mb-3">
                  <div className="d-flex gap-2 align-items-center mb-2">
                    <p className="m-0">Справка о постановке на учет физлица</p>
                    <Tooltip
                      position="bottom"
                      text="Справка о постановке на учет (снятие с учета) физического лица в качестве налогоплательщика налога на профессиональный доход"
                    />
                  </div>
                  <div className="d-flex gap-3 align-items-center">
                    <label className="btn-files w-auto">
                      <input
                        type="file"
                        accept={fileAccept}
                        hidden
                        disabled={registerSelfBlocked}
                        onChange={async (e) => {
                          setRegisterSelfBlocked(true);
                          await showModalErrorType(
                            userData["id"],
                            "nalog_register_self",
                            e.target.files[0]
                          );
                          setApproved("nalog_register_self_approved");
                          setRegisterSelfBlocked(false);
                          setIsFileBtnTouched(true);
                        }}
                      />
                      <img src={plus} alt="" />
                    </label>
                    <div className="d-flex gap-2 align-items-center">
                      {userFiles["nalog_register_self"] &&
                      userFiles["nalog_register_self"] !== -1 ? (
                        <img
                          alt=""
                          src={iconCheck}
                          className={
                            userData["nalog_register_self_approved"] == "1"
                              ? "iconCheck_approved"
                              : ""
                          }
                        />
                      ) : null}
                      {userFiles["nalog_register_self"] &&
                      userFiles["nalog_register_self"] !== -1 ? (
                        <FilesInfo
                          hasFiles={
                            userFiles["nalog_register_self"] &&
                            userFiles["nalog_register_self"] !== -1
                          }
                        >
                          {[
                            {
                              file: userFiles["nalog_register_self"],
                              handleClick: () => {
                                setOpenModalDocument(true);
                                setDocumentUrl(
                                  `${baseUrl}${
                                    userFiles["nalog_register_self"]
                                  }?${Date.now()}`
                                );
                              }
                            }
                          ]}
                        </FilesInfo>
                      ) : (
                        <div className="information-label text-end">
                          Прикрепите файл
                        </div>
                      )}
                    </div>
                  </div>
                </Form.Group>
              ) : values["contract_type"] === "ip" ? (
                <Form.Group className="mb-3">
                  <div className="d-flex gap-2 align-items-center mb-2">
                    <p className="m-0">ОГРНИП/ЕГРИП</p>
                    <Tooltip
                      position="bottom"
                      text="Уведомление о постановке на учет физического лица в налоговом Органе"
                    />
                  </div>
                  <div className="d-flex gap-3 align-items-center">
                    <label className="btn-files w-auto">
                      <input
                        type="file"
                        accept={fileAccept}
                        hidden
                        disabled={registerIPBlocked}
                        onChange={async (e) => {
                          setRegisterIPBlocked(true);
                          await showModalErrorType(
                            userData["id"],
                            "nalog_register_ip",
                            e.target.files[0]
                          );
                          setApproved("nalog_register_ip_approved");
                          setRegisterIPBlocked(false);
                          setIsFileBtnTouched(true);
                        }}
                      />
                      <img src={plus} alt="" />
                    </label>
                    <div className="d-flex gap-2 align-items-center">
                      {userFiles["nalog_register_ip"] &&
                      userFiles["nalog_register_ip"] !== -1 ? (
                        <img
                          alt=""
                          src={iconCheck}
                          className={
                            userData["nalog_register_ip_approved"] == "1"
                              ? "iconCheck_approved"
                              : ""
                          }
                        />
                      ) : null}
                      {userFiles["nalog_register_ip"] &&
                      userFiles["nalog_register_ip"] !== -1 ? (
                        <FilesInfo
                          hasFiles={
                            userFiles["nalog_register_ip"] &&
                            userFiles["nalog_register_ip"] !== -1
                          }
                        >
                          {[
                            {
                              file: userFiles["nalog_register_ip"],
                              handleClick: () => {
                                setOpenModalDocument(true);
                                setDocumentUrl(
                                  `${baseUrl}${
                                    userFiles["nalog_register_ip"]
                                  }?${Date.now()}`
                                );
                              }
                            }
                          ]}
                        </FilesInfo>
                      ) : (
                        <div className="information-label text-end">
                          Прикрепите файл
                        </div>
                      )}
                    </div>
                  </div>
                </Form.Group>
              ) : null}

              <Form.Group className="mb-3">
                <Form.Label className="d-flex justify-content-between align-items-center m-0 mb-1 w-100">
                  <div className="d-flex gap-2">
                    <p className="m-0">СНИЛС*</p>
                    {userFiles["snils"] !== -1 ? (
                      <img
                        alt=""
                        src={iconCheck}
                        className={
                          userData["snils_approved"] == "1"
                            ? "iconCheck_approved"
                            : ""
                        }
                      />
                    ) : null}
                    <div className="files-info-container files-info-container_small">
                      <FilesInfo hasFiles={userFiles["snils"] !== -1}>
                        {[
                          {
                            file: userFiles["snils"],
                            handleClick: () => {
                              setOpenModalDocument(true);
                              setDocumentUrl(
                                `${baseUrl}${userFiles["snils"]}?${Date.now()}`
                              );
                            }
                          }
                        ]}
                      </FilesInfo>
                    </div>
                  </div>
                  {userFiles["snils"] !== -1 ? null : (
                    <div className="information-form__label text-end">
                      Прикрепите файл
                    </div>
                  )}
                </Form.Label>
                <div className="d-flex gap-2 flex-wrap">
                  <Form.Group className="flex-grow-1 info-row">
                    <Field name="snils">
                      {({ field }) => (
                        <MaskedInput
                          {...field}
                          mask={snilsNumberMask}
                          placeholder="000-000-000 00"
                          value={values.snils}
                          type="text"
                          onFocus={(e) => setFieldTouched(e.target.name, true)}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`information-placeholder ${
                            errors.snils && touched.snils
                              ? "form-control is-invalid"
                              : "form-control"
                          }`}
                        />
                      )}
                    </Field>
                    <Form.Control.Feedback type="invalid">
                      {errors.snils}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <div className="d-flex align-items-center gap-3 align-self-start">
                    <label className="btn-files w-auto">
                      <input
                        type="file"
                        accept={fileAccept}
                        hidden
                        disabled={snilsFileBlocked}
                        onChange={async (e) => {
                          setSnilsFileBlocked(true);
                          await showModalErrorType(
                            userData["id"],
                            "snils",
                            e.target.files[0]
                          );
                          setApproved("snils_approved");
                          setSnilsFileBlocked(false);
                          setIsFileBtnTouched(true);
                        }}
                      />
                      <img src={plus} alt="" />
                    </label>
                    {userFiles["snils"] !== -1 ? (
                      <div className="files-container">
                        <FilesInfo hasFiles={userFiles["snils"] !== -1}>
                          {[
                            {
                              file: userFiles["snils"],
                              handleClick: () => {
                                setOpenModalDocument(true);
                                setDocumentUrl(
                                  `${baseUrl}${
                                    userFiles["snils"]
                                  }?${Date.now()}`
                                );
                              }
                            }
                          ]}
                        </FilesInfo>
                      </div>
                    ) : (
                      <div className="information-form__label information-form__label_small text-end">
                        Прикрепите файлы
                      </div>
                    )}
                  </div>
                </div>
              </Form.Group>

              <div className="mb-3">
                <Form.Label className="d-flex justify-content-between align-items-center m-0 mb-1 w-100">
                  <div className="d-flex gap-2">
                    <p className="m-0">ИНН*</p>
                    {userFiles["inn"] !== -1 ? (
                      <img
                        alt=""
                        src={iconCheck}
                        className={
                          userData["inn_approved"] === "1"
                            ? "iconCheck_approved"
                            : ""
                        }
                      />
                    ) : null}
                    <div className="files-info-container files-info-container_small">
                      <FilesInfo hasFiles={userFiles["inn"] !== -1}>
                        {[
                          {
                            file: userFiles["inn"],
                            handleClick: () => {
                              setOpenModalDocument(true);
                              setDocumentUrl(
                                `${baseUrl}${userFiles["inn"]}?${Date.now()}`
                              );
                            }
                          }
                        ]}
                      </FilesInfo>
                    </div>
                  </div>
                  {userFiles["inn"] !== -1 ? null : (
                    <div className="information-form__label text-end">
                      Прикрепите файл
                    </div>
                  )}
                </Form.Label>
                <div className="d-flex gap-2 flex-wrap">
                  <Form.Group className="flex-grow-1 info-row">
                    <Form.Control
                      className="information-placeholder"
                      type="tel"
                      placeholder="12-значный номер"
                      name="inn"
                      value={values.inn}
                      onChange={handleChange}
                      onFocus={(e) => setFieldTouched(e.target.name, true)}
                      onBlur={handleBlur}
                      isInvalid={touched.inn && errors.inn}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.inn}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <div className="d-flex align-items-center gap-3 align-self-start">
                    <label className="btn-files w-auto">
                      <input
                        type="file"
                        accept={fileAccept}
                        hidden
                        disabled={innFileBlocked}
                        onChange={async (e) => {
                          setInnFileBlocked(true);
                          await showModalErrorType(
                            userData["id"],
                            "inn",
                            e.target.files[0]
                          );
                          setApproved("inn_approved");
                          setInnFileBlocked(false);
                          setIsFileBtnTouched(true);
                        }}
                      />
                      <img src={plus} alt="" />
                    </label>
                    {userFiles["inn"] !== -1 ? (
                      <div className="files-container">
                        <FilesInfo hasFiles={userFiles["inn"] !== -1}>
                          {[
                            {
                              file: userFiles["inn"],
                              handleClick: () => {
                                setOpenModalDocument(true);
                                setDocumentUrl(
                                  `${baseUrl}${userFiles["inn"]}?${Date.now()}`
                                );
                              }
                            }
                          ]}
                        </FilesInfo>
                      </div>
                    ) : (
                      <div className="information-form__label information-form__label_small text-end">
                        Прикрепите файлы
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <Form.Label>Банковские реквизиты</Form.Label>
                <div className="d-flex gap-2 flex-wrap">
                  <Form.Group className="flex-grow-1 w-100">
                    <Form.Control
                      className="information-placeholder"
                      type="tel"
                      name="bankaccount"
                      placeholder="Расчетный счет"
                      value={values.bankaccount}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isInvalid={touched.bankaccount && errors.bankaccount}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.bankaccount}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="flex-grow-1 w-100">
                    <Form.Control
                      className="information-placeholder"
                      type="text"
                      name="bankname"
                      placeholder="Наименование банка"
                      value={values.bankname}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isInvalid={touched.bankname && errors.bankname}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.bankname}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <div className="d-flex gap-2 flex-wrap w-100">
                    <Form.Group className="flex-grow-1 info-row">
                      <Form.Control
                        className="information-placeholder"
                        type="tel"
                        name="banknumber"
                        placeholder="ИНН банка"
                        value={values.banknumber}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.banknumber && errors.banknumber}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.banknumber}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="flex-grow-1 info-row">
                      <Form.Control
                        className="information-placeholder"
                        type="tel"
                        name="bankbik"
                        placeholder="БИК"
                        value={values.bankbik}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.bankbik && errors.bankbik}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.bankbik}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  <div className="d-flex gap-2 flex-wrap w-100">
                    <Form.Group className="flex-grow-1 info-row">
                      <Form.Control
                        className="information-placeholder"
                        type="tel"
                        name="bankkpp"
                        placeholder="КПП"
                        value={values.bankkpp}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.bankkpp && errors.bankkpp}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.bankkpp}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="flex-grow-1 info-row">
                      <Form.Control
                        className="information-placeholder"
                        type="tel"
                        name="bankkor"
                        placeholder="Корр. счет"
                        value={values.bankkor}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.bankkor && errors.bankkor}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.bankkor}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  <Form.Group className="flex-grow-1 w-100">
                    <Form.Control
                      className="information-placeholder"
                      type="text"
                      name="bank_recipient"
                      placeholder="Получатель"
                      value={values.bank_recipient}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isInvalid={
                        touched.bank_recipient && errors.bank_recipient
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.bank_recipient}
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>
              </div>

              <div className="mb-4">
                <Form.Label className="d-flex align-items-center m-0 mb-1 w-100 gap-2">
                  <div>Дополнительные документы</div>
                  <Tooltip
                    position="bottom-center"
                    text="Можно прикрепить до 5 дополнительных документов"
                  />
                </Form.Label>
                <div className="d-flex align-items-center gap-3">
                  <label className="btn-files w-auto">
                    <input
                      type="file"
                      accept={fileAccept}
                      hidden
                      multiple
                      disabled={addDocsBlocked}
                      onChange={async (e) => {
                        setAddDocsBlocked(true);
                        setAddDocsError(null);
                        const files = e.target.files;
                        if (files.length > 5) {
                          setAddDocsError("Не более 5 файлов");
                          setAddDocsBlocked(false);
                        } else {
                          await showModalErrorTypeSeveral(
                            userData["id"],
                            files
                          );
                          setAddDocsBlocked(false);
                          setIsFileBtnTouched(true);
                        }
                      }}
                    />
                    <img src={plus} alt="" />
                  </label>
                  {userFiles &&
                  [2, 3, 4, 5, 6]
                    .map((num) => `passport${num}`)
                    .some((val) => userFiles[val] !== -1) ? (
                    <div>
                      <FilesInfo
                        hasFiles={[2, 3, 4, 5, 6]
                          .map((num) => `passport${num}`)
                          .some((val) => userFiles[val])}
                      >
                        {[2, 3, 4, 5, 6]
                          .map((num) => `passport${num}`)
                          .map((val) => {
                            return {
                              file: userFiles[val],
                              handleClick: () => {
                                setOpenModalDocument(true);
                                setDocumentUrl(
                                  `${baseUrl}${userFiles[val]}?${Date.now()}`
                                );
                              }
                            };
                          })}
                      </FilesInfo>
                    </div>
                  ) : (
                    <div className="information-form-label text-end">
                      Прикрепите файлы
                    </div>
                  )}
                </div>
                {addDocsError ? (
                  <div className="addDocs-error mt-2">Не более 5 файлов</div>
                ) : null}
              </div>
              <div className="information-btns">
                <button
                  type="submit"
                  onClick={handleSubmit}
                  disabled={
                    hasChecked ||
                    (!dirty && !isFileBtnTouched) ||
                    !isValid ||
                    !hasRequiredFields ||
                    !hasRequiredFiles
                  }
                  className="information-mainbtn information-mainbtn_check"
                >
                  Отправить на проверку
                </button>
                <button
                  type="button"
                  disabled={(!isFileBtnTouched && !dirty) || !isValid}
                  className="information-mainbtn information-mainbtn_save"
                  onClick={async () => {
                    await refreshUserData(values);
                    newData();
                  }}
                >
                  Сохранить изменения
                </button>

                {tooltipMessage && (
                  <div className="information-tooltip">{tooltipMessage}</div>
                )}
              </div>
            </Form>
            </>
          );
        }}
      </Formik>
      <ShowDocument
        show={openModalDocument}
        onHide={() => setOpenModalDocument(false)}
        documentUrl={documentUrl}
      />
      <FileUploadErrorModal
        show={fileUploadErrorModal}
        onHide={() => setFileUploadErrorModal(false)}
      />
    </>
  );
};

export default inject(({ usersStore, filesStore, modalWindows }) => {
  const {
    sendAgentFile,
    inn,
    snils,
    passport,
    documentUrl,
    setOpenModalDocument,
    setDocumentUrl,
    openModalDocument,
    setApproved
  } = filesStore;
  const { userData, userFiles, userRequired, refreshUserData } = usersStore;
  const { setFileUploadErrorModal, fileUploadErrorModal } = modalWindows;

  return {
    sendAgentFile,
    inn,
    snils,
    passport,
    userData,
    userFiles,
    userRequired,
    refreshUserData,
    documentUrl,
    setOpenModalDocument,
    setDocumentUrl,
    openModalDocument,
    setFileUploadErrorModal,
    fileUploadErrorModal,
    setApproved
  };
})(observer(Documents));
